var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.552124 1.49805V4.49884H3.58637",
    stroke: "#C5C5D1",
    strokeWidth: 0.750197,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.6776 9.50079V6.5H8.64331",
    stroke: "#C5C5D1",
    strokeWidth: 0.750197,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.4084 3.99961C10.1519 3.28281 9.71598 2.64195 9.14133 2.13683C8.56668 1.6317 7.87201 1.27877 7.12213 1.11098C6.37226 0.943178 5.59162 0.965979 4.85307 1.17725C4.11452 1.38852 3.44212 1.78138 2.89861 2.31916L0.552124 4.49974M11.6777 6.50026L9.33121 8.68084C8.7877 9.21862 8.1153 9.61148 7.37674 9.82275C6.63819 10.034 5.85756 10.0568 5.10768 9.88903C4.35781 9.72123 3.66314 9.3683 3.08848 8.86317C2.51383 8.35805 2.07793 7.71719 1.82145 7.00039",
    stroke: "#C5C5D1",
    strokeWidth: 0.750197,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.83f6dc0c0c7e0f63e3aaf08e675b4ac5.svg";
export { ForwardRef as ReactComponent };